import React, { ReactNode, createContext } from 'react';

import type { AwsRum as AwsRumClient } from 'aws-rum-web';

type AwsRumClientContextType = {
  awsRum: AwsRumClient | null;
};

export const AwsRumClientContext = createContext<AwsRumClientContextType>({
  awsRum: null,
});

export const AwsRumClientProvider: React.FC<{
  children: ReactNode;
  awsRum: AwsRumClient | null;
}> = ({ children, awsRum }) => {
  return <AwsRumClientContext.Provider value={{ awsRum }}>{children}</AwsRumClientContext.Provider>;
};
